import React from 'react';

const Vue_Instance_Options_computed = () => {
  return (
    <div>
      <h1>Vue_Instance_Options_computed Component</h1>
      <p>This is the Vue_Instance_Options_computed tutorial page.</p>
    </div>
  );
}

export default Vue_Instance_Options_computed;
